export default {
    "apiUrl": 'https://api-mmnyein.cactusminds.com/backend/',
    "audioUrl": 'https://api-mmnyein.cactusminds.com/',
    // "apiUrl": 'http://localhost:8000/backend/',
    // "audioUrl": 'http://localhost:8000/',
}